import UMMOConfig from "config";

export default function ForceReload() {
  //find the hai object from the config
  const findHAIdata = UMMOConfig.products.find((d) => d.key === "hai");

  window.location.replace(findHAIdata.link); //force redirect to link from config
  return <></>;
}
